import type { InvoiceItem } from "@js/types/invoices";

export const INVOICE_FORM_ID = "addInvoiceForm";

export type InvoiceFormItemData = Partial<
  Pick<
    InvoiceItem,
    | "date_from"
    | "date_to"
    | "description"
    | "po_number"
    | "unit_price"
    | "tax_name"
    | "tax_rate"
    | "item_type"
  >
> & {
  quantity: string;
};

export type InvoiceFormData = {
  job: number | undefined;
  number: string | undefined;
  issued_at: string;
  notes_to_receipt?: string | null;
  new_items?: Array<InvoiceFormItemData>;
  employer: number;
};
